import { MenuItem } from '@v2/shared/lib/types';
import { MenuPanel } from '@v2/brands/discountmags/Layouts/Full/Navigation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';

type Props = {
  socialLinks: MenuItem[];
};

export default function ConnectWithUsPanel({ socialLinks }: Props) {
  return (
    <MenuPanel flush>
      <MenuPanel.Title padded title="Connect With Us" />
      <div className="flex px-4 pb-4">
        {socialLinks?.map(({ href, icon }) => (
          <a
            href={href}
            key={href}
            target="_blank"
            rel="noreferrer"
            className="block cursor-pointer mr-3 text-2xl text-slate-600"
          >
            <FontAwesomeIcon icon={icon ? icon : faInfoCircle} fixedWidth />
          </a>
        ))}
      </div>
    </MenuPanel>
  );
}
